import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from "~/atoms/tooltip";
import GiftIcon from "~/icons/GiftIcon";

const now = new Date();
const valentinesDay = new Date(now.getFullYear(), 1, 14);
const dayOfWeek = valentinesDay.getDay(); // 0=Sun, 6=Sat
const isValentinesWeekend = dayOfWeek === 0 || dayOfWeek === 6;

export const isValentinesSeason =
  now.getMonth() === 1 &&
  (isValentinesWeekend
    ? now.getDate() >= 13 && now.getDate() <= 15
    : now.getDate() === 14);

export function ValentineGift() {
  const { t } = useTranslation();

  if (!isValentinesSeason) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="cursor-help">
          <GiftIcon className="animate-valentineFloat h-14 w-14" />
        </TooltipTrigger>
        <TooltipContent>
          <p>{t(($) => $.commons.seasonal.valentines)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
